// Helpers para los niveles de límite estándar de Auto (Panamá).
// Tipos: LC = Lesiones Corporales, DPA = Daños a la Propiedad Ajena, GM = Gastos Médicos.

// Rango de marcas diacríticas combinantes (acentos) en Unicode.
const DIACRITICOS = /[̀-ͯ]/g;

/**
 * Detecta el tipo (LC/DPA/GM) a partir del nombre de la cobertura.
 * Case-insensitive y tolerante a acentos. Devuelve null si no aplica.
 */
export function detectAutoTipo(nombre) {
  const n = (nombre || '')
    .toLowerCase()
    .normalize('NFD').replace(DIACRITICOS, ''); // quita acentos
  if (!n) return null;
  // DPA primero (evita falsos positivos con "daños")
  if (n.includes('propiedad ajena') || /\bdpa\b/.test(n)) return 'DPA';
  if (n.includes('lesion') || /\blc\b/.test(n)) return 'LC';
  if (n.includes('gastos medicos') || n.includes('gasto medico') ||
      n.includes('medico') || /\bgm\b/.test(n)) return 'GM';
  return null;
}

/**
 * Filtra las opciones de auto_limite_opciones por tipo, ya ordenadas por `orden`.
 */
export function autoOpcionesPorTipo(opciones, tipo) {
  if (!tipo || !Array.isArray(opciones)) return [];
  return opciones
    .filter(o => o.tipo === tipo)
    .sort((a, b) => (a.orden || 0) - (b.orden || 0));
}
